import _partition from 'lodash/partition';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  toggleGoogleInviteModal,
  updateGoogleContactInfo,
} from 'actions/google';
import { GOOGLE_INVITE_MODAL_VIEWED, INVITE_SENT } from 'constants/events';
import {
  fetchGoogleInfoCreator,
  postGoogleInviteCreator,
} from 'creators/google';
import * as analytics from 'utilities/analytics';

import avatarPlaceholder from 'img/icons/comments-avatar-placeholder.svg';

import { INVITE_TEAM_VIEW_THRESHOLD } from '../../../../../shared/constants/invites';

import Button from 'components/ui-components/button';
import Checkbox from 'components/ui-components/checkbox';
import Spinner from 'components/ui-components/circular-loading-spinner';

import './styles.less';

const InvitePane = class extends Component {
  state = {
    peopleList: [],
    inviteCount: 0,
    query: '',
    forceUpdate: false,
  };

  render() {
    const { peopleList, inviteCount } = this.state;
    const { selections, googleContactInfo } = this.props;
    const isEveryoneSelected = selections.length === googleContactInfo.length;

    const [onLoom, notOnLoom] = _partition(
      peopleList,
      person => person.loom_user
    );
    const [withPic, withoutPic] = _partition(
      notOnLoom,
      notOnLoom => notOnLoom.photo.url
    );
    const peopleListSorted = withPic.concat(withoutPic).concat(onLoom);

    const disableSearch =
      peopleListSorted.length === 0 && this.state.query === '';

    return (
      <div className="google-share-modal-backdrop" onClick={this.onClose}>
        <div className="google-share-modal" onClick={e => e.stopPropagation()}>
          <div className="close" onClick={this.onClose} />
          <h2 className="prompt">🔓 Who Viewed Your Video</h2>
          <p className="instructions">
            Invite {INVITE_TEAM_VIEW_THRESHOLD} people via email to Loom and
            instantly unlock the ability to see who views your video.
          </p>
          <div className="search-invi">
            <input
              className="search-input"
              placeholder={disableSearch ? '' : 'Search to add people...'}
              onChange={this.filterPeople}
              disabled={disableSearch}
            />
          </div>
          <ul className="people-list">
            {peopleListSorted.length > 0 &&
              peopleListSorted.map(person => {
                return (
                  <li
                    className={`person ${person.active ? 'selected' : ''}`}
                    key={person.id}
                    onClick={
                      !person.loom_user
                        ? () => this.selectionHandler(person.id)
                        : () => {}
                    }
                  >
                    <div className="avatar">
                      {person.photo.url && (
                        <img className="avatar-image" src={person.photo.url} />
                      )}
                      {!person.photo.url && (
                        <img className="placeholder" src={avatarPlaceholder} />
                      )}
                    </div>
                    <div className="id-info">
                      <div className="govt-name">
                        {(person.name && person.name.displayName) ||
                          person.email.value}
                        {person.loom_user && (
                          <span className="on-loom">Already on Loom</span>
                        )}
                      </div>
                      <div className="slack-handle">{person.email.value}</div>
                    </div>
                    {!person.loom_user && (
                      <Checkbox
                        isChecked={person.active}
                        onEnable={() => this.selectionHandler(person.id)}
                        onDisable={() => this.selectionHandler(person.id)}
                      />
                    )}
                  </li>
                );
              })}
            {peopleListSorted.length === 0 &&
              !this.props.fetching &&
              this.state.query !== '' && (
                <li className="person no-results">
                  No matches for {this.state.query}
                </li>
              )}
            {peopleListSorted.length === 0 &&
              !this.props.fetching &&
              this.state.query === '' && (
                <li className="person no-results">No contacts found</li>
              )}
            {peopleListSorted.length === 0 && this.props.fetching && (
              <div className="spinner">
                <Spinner color="dark" />
              </div>
            )}
          </ul>
          <div className="select-all">
            <span
              className="select-all-text"
              onClick={() => {
                isEveryoneSelected
                  ? this.deselectAllHandler()
                  : this.selectAllHandler();
              }}
            >
              {`${isEveryoneSelected ? 'Deselect' : 'Select'} All Friends`}
            </span>
          </div>
          <Button
            buttonType="a1"
            buttonClass="invite-button"
            value={
              inviteCount < 3
                ? `Select ${INVITE_TEAM_VIEW_THRESHOLD - inviteCount} friends`
                : 'Unlock Now'
            }
            onClicked={this.sendInvites}
            disabled={inviteCount < 3}
          />
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.filterPeople();

    analytics.track(GOOGLE_INVITE_MODAL_VIEWED, {
      modal_step: 'invite_list',
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.query !== this.state.query || prevState.forceUpdate) {
      this.filterPeople();

      this.setState({ forceUpdate: false });
    }

    const { googleFetched, fetching } = this.props;

    if (
      this.props.googleContactInfo.length === 0 &&
      !googleFetched &&
      !fetching
    ) {
      this.props.fetchGoogleInfoCreator();
    }

    if (googleFetched && !prevProps.googleFetched) {
      this.filterPeople();
    }
  }

  sendInvites = () => {
    const { selections, user } = this.props;

    selections.forEach(person => {
      const { id, email, name } = person;

      const firstName = name && (name.givenName || name.familyName);

      this.props.postGoogleInviteCreator({
        invitee_google_id: id,
        inviter_id: user.id,
        invitee_email: email.value,
        inviter_first_name: user.first_name || user.last_name,
        invitee_first_name: firstName,
      });
    });

    analytics.track(INVITE_SENT, {
      number_of_invitees: selections.length,
      source: 'Google Contacts Invite Modal',
      company: user.company_name,
      inviter_position: user.company_position,
    });
  };

  selectionHandler = id => {
    const { googleContactInfo, selections } = this.props;

    let item = null;
    let newSelections = null;

    const newContactInfo = googleContactInfo.map(contact => {
      if (contact.id === id) {
        item = { ...contact, active: !contact.active };

        if (contact.active) {
          newSelections = selections.filter(selection => selection.id !== id);
        } else {
          newSelections = selections.concat([item]);
        }

        return item;
      }

      return contact;
    });

    this.props.updateGoogleContactInfo(newContactInfo, newSelections);
    this.setState({ forceUpdate: true });
  };

  selectAllHandler = () => {
    const { googleContactInfo } = this.props;

    const newContactInfo = googleContactInfo.map(contact => {
      return { ...contact, active: true };
    });

    // we spread the object in the second arg to make sure we don't reference
    // the same object in redux
    this.props.updateGoogleContactInfo(newContactInfo, newContactInfo.slice());
    this.setState({ forceUpdate: true });
  };

  deselectAllHandler = () => {
    const { googleContactInfo } = this.props;

    const newContactInfo = googleContactInfo.map(contact => {
      return { ...contact, active: false };
    });

    this.props.updateGoogleContactInfo(newContactInfo, []);
    this.setState({ forceUpdate: true });
  };

  filterPeople = e => {
    const { googleContactInfo, selections } = this.props;
    const targetQuery = e && e.target && e.target.value;
    const query = targetQuery === '' ? '' : targetQuery || this.state.query;

    const filteredPeople = googleContactInfo.filter(contact => {
      if (!contact) {
        return false;
      }

      if (query === '') {
        return true;
      }

      const q = query.toLowerCase().trim();
      const email = contact.email && contact.email.value.toLowerCase().trim();
      const name =
        contact.name && contact.name.displayName.toLowerCase().trim();

      return (email && email.startsWith(q)) || (name && name.startsWith(q));
    });

    this.setState({
      query,
      peopleList: filteredPeople,
      inviteCount: selections.length,
    });
  };

  onClose = () => {
    this.props.toggleGoogleInviteModal(false);
  };
};

const mapStateToProps = state => {
  const { google, user } = state;

  const {
    contact_info,
    first_fetch_done: googleFetched,
    selections,
    fetching,
  } = google;

  return {
    googleContactInfo: contact_info || [],
    user: user && user.current,
    googleFetched,
    selections,
    fetching,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleGoogleInviteModal: show => dispatch(toggleGoogleInviteModal(show)),
    fetchGoogleInfoCreator: () => dispatch(fetchGoogleInfoCreator()),
    updateGoogleContactInfo: (info, changed) =>
      dispatch(updateGoogleContactInfo(info, changed)),
    postGoogleInviteCreator: info => dispatch(postGoogleInviteCreator(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvitePane);
